import Header from "../components/Header";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Manifesto from "../components/Manifesto";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Booking from "../components/Booking";
import Footer from "../components/Footer";
import SmoothScroll from "../components/SmoothScroll";
import CookieBanner from "../components/CookieBanner";
import WhatsAppFloat from "../components/WhatsAppFloat";

export default function HomePage() {
  return (
    <SmoothScroll>
      <div className="grain min-h-screen bg-[color:var(--bg-primary)] text-[color:var(--text-primary)]">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Manifesto />
          <Services />
          <Gallery />
          <Booking />
        </main>
        <Footer />
        <CookieBanner />
        <WhatsAppFloat />
      </div>
    </SmoothScroll>
  );
}
